import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Link, useParams, useNavigate } from "react-router-dom";
import Images from "../Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Loading from "../Components/Loading";
import ChangeOfArticleTable from "../Components/Services/ChangeOfArticleTable";
import ChangeOfNameTable from "../Components/Services/ChangeOfNameTable";
import ChangeOfCorrectionTable from "../Components/Services/ChangeOfCorrectionTable";
import ChangeOfAddressTable from "../Components/Services/ChangeOfAddressTable";
import UploadCertificateModel from "../Components/Applications/UploadCertificateModel";

import ViewModel from "../Components/Services/ViewModel";
//import EditModel from "../Components/Applications/UpdateStatusModel";
//import UpdateStatusModel from "../Components/Services/UpdateStatusMode";
import UpdateStatusModel from "../Components/Services/ConsentModel";

import Navbar from "../Components/Navbar";
import Config from "../Config";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  FieldWrapper,
  InputGroup,
  Label,
  SmallBtn,
} from "../Components/Styles/InputStyles";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  ErrorText,
} from "../Components/Styles/PageStyles";
import NotFoundModel from "../Components/NotFoundModel";
import DeleteModel from "../Components/Services/DeleteModel";
import { useSelector } from "react-redux";
import { ForUs } from "../Config";
import { MdAdd } from "react-icons/md";
//import { HiUpload } from "rFeact-icons/hi";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const OtherServices = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [searchType, setSearchType] = useState("0");
  const [serviceType, setServiceType] = useState("1");

  const [openUpdateStatusModel, setUpdateStatusModel] = useState(false);
  const [openUploadCertificateModel, setOpenUploadCertificateModel] =
    useState(false);

  const [openViewModel, setOpenViewModel] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [openEditModel, setOpenEditModel] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // const [selectedItem, setSelectedItem] = useState("");
  const [selectedData, setSelectedData] = useState("");
  const [deviceId, setDeviceId] = useState("");
  const [deviceType, setDeviceType] = useState("");

  const [editDevice, setEditDevice] = useState(false);

  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(60, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { id } = useParams();

  // // ----- Getting Initial Data ------
  const fetchFunction = async (values) => {
    const body = new FormData();
    body.append("token", user.id);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("status", values.status);
    body.append("serviceType", values.serviceType);
    return await axios.post(`${Config.apiUrl}/otherserviceslist`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  // const { isLoading, error, data, refetch, isRefetching } = useQuery(
  //   "getMyRequestsList",
  //   fetchFunction
  // );

  const getAppReSuccess = (res) => {
    if (res.data.status == "NOK") error = true;
  };

  const getAppReError = (res) => {};

  const {
    isLoading: isLoading,
    mutate: getAppRegMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getAppReSuccess,
    onError: getAppReError,
  });

  useEffect(() => {
    let values = {
      status: "0",
      serviceType: "1",
    };

    getAppRegMutate(values);
  }, []);

  const initialValues = {
    startDate: moment(new Date()).subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    let filter = {
      status: searchType,
      serviceType: serviceType,
    };
    getAppRegMutate(filter);
    //getReportsMutate(newValues);
  };

  const searchHandler = (value) => {
    //console.log(value);
    //setSearchType(value)
    let values = {
      status: value,
      serviceType: serviceType,
    };
    getAppRegMutate(values);
    //getReportsMutate(newValues);
  };

  const serviceHandler = (value) => {
    //setServiceType(value)
    let values = {
      status: searchType,
      serviceType: value,
    };
    getAppRegMutate(values);
    //getReportsMutate(newValues);
  };

  //------- Update Status -------
  const UpdateStatusFunction = async (values) => {
    const body = new FormData();
    // console.log(values);
    body.append("id", values.id);
    body.append("userType", user.userType);
    body.append("serviceType", serviceType);
    body.append("remarks", values.remarks);
    body.append("status", values.status);
    body.append("consent", values.consent);
    body.append("name", selectedItem.newName);
    body.append("assocId", selectedItem.assocId);

    return await axios.post(`${Config.apiUrl}/updateotherservicestatus`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUpdateStatusSuccess = (res) => {
    //refetch();
    if (res?.data?.status == "OK") {
      let filter = {
        status: searchType,
        serviceType: serviceType,
      };
      getAppRegMutate(filter);
      setUpdateStatusModel(false);
      toast.success(res?.data?.msg || "Success");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onUpdateStatusError = (res) => {
    setUpdateStatusModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: UpdateStatusLoading, mutate: postUpdateStatus } =
    useMutation(UpdateStatusFunction, {
      onSuccess: onUpdateStatusSuccess,
      onError: onUpdateStatusError,
    });

  //------- Upload Certificate -------
  const UploadCertificateFunction = async (values) => {
    const body = new FormData();
    //body.append("token", user.token);
    body.append("appId", values.appId);
    body.append("cerificate", values.fileName);
    body.append("serviceType", values.serviceType);
    return await axios.post(`${Config.apiUrl}/uploadcert`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onUploadCertificateSuccess = (res) => {
    //refetch();

    if (res?.data?.status == "OK") {
      getAppRegMutate(searchType);
      setOpenUploadCertificateModel(false);
      toast.success(res?.data?.msg || "Success");
    } else toast.error(res?.data?.msg || "Error");
  };

  const onUploadCertificateError = (res) => {
    setOpenUploadCertificateModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: UploadCertificateLoading, mutate: postUploadCertificate } =
    useMutation(UploadCertificateFunction, {
      onSuccess: onUploadCertificateSuccess,
      onError: onUploadCertificateError,
    });

  /************ Generate Digital Certificate *************/

  const generateCertificateApi = async (values) => {
    const body = new FormData();
    body.append("appId", values.assocId);
    body.append("serviceType", 3);
    return await axios.post(`${Config.apiUrl}/generatecertificate`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onGenerateCertificateSuccess = (res) => {
    if (res?.data?.status == "OK") {
      toast.success(res?.data?.msg || "Success");
      getAppRegMutate(searchType);
    } else toast.error(res?.data?.msg || "Error");
  };

  const onGenerateCertificateError = (res) => {
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: GenerateCertificateLoading, mutate: generateCertificate } =
    useMutation(generateCertificateApi, {
      onSuccess: onGenerateCertificateSuccess,
      onError: onGenerateCertificateError,
    });

  /******************* End Geneate Digital Certificate ***********************************/

  const deleteDeviceHandler = async (values) => {
    const body = new FormData();
    body.append("id", values?.id);
    body.append("type", values?.type);
    return await axios.post(
      // Config.DeleteDeviceApi,
      `${Config.apiUrl}/deleteotherservices`,
      body,
      {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
      // { selectedData: id, status: 0 },
      // Config.AxiosConfig
    );
  };

  const onDeleteDeviceSuccess = (data) => {
    if (data?.data?.status == "OK") {
      let filter = {
        status: searchType,
        serviceType: serviceType,
      };
      getAppRegMutate(filter);

      setSelectedItem("");
      setOpenDeleteModel(false);
      // console.log("success", data);
      toast.success(data?.data?.msg || "Success");
    } else toast.error(data?.data?.msg || "Error");
  };

  const onDeleteDeviceError = (data) => {
    setOpenDeleteModel(false);
    setSelectedItem("");
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteDeviceLoading, mutate: deleteDeviceMutate } =
    useMutation(deleteDeviceHandler, {
      onSuccess: onDeleteDeviceSuccess,
      onError: onDeleteDeviceError,
    });

  return (
    <>
      <Navbar />
      <Page>
        {openDeleteModel && (
          <DeleteModel
            deleteDeviceLoading={deleteDeviceLoading}
            setOpenDeleteModel={setOpenDeleteModel}
            selectedData={selectedData}
            selectedItem={selectedItem}
            deleteDeviceMutate={deleteDeviceMutate}
            deviceId={selectedItem.id}
            deviceType={selectedItem.serviceType}
          />
        )}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("Other_Services")}</Title>
              <Underline />
            </div>
            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>

          <div className="flex flex-col space-y-6  lg:space-y-0 lg:flex-row lg:items-end lg:justify-between">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              user={user}
            />
            <div className="flex items-center space-x-8">
              <InputGroup className="max-w-xs" style={{ flexBasis: "content" }}>
                <Label htmlFor="startDate">Status</Label>
                <Select
                  autoComplete="off"
                  style={{ height: "40px" }}
                  className="w-32 pl-2 bg-transparent text-sm p-0 border-none"
                  value={searchType}
                  onChange={(e) => {
                    setSearchType(e.target.value);
                    searchHandler(e.target.value);
                  }}
                >
                  <MenuItem value="0">All</MenuItem>
                  <MenuItem value="1">Pending</MenuItem>
                  <MenuItem value="2">Completed</MenuItem>
                </Select>
              </InputGroup>
              <InputGroup className="w-full" style={{ flexBasis: "content" }}>
                <Label htmlFor="startDate">Select Service</Label>
                <Select
                  autoComplete="off"
                  style={{ height: "40px" }}
                  className="w-48 pl-2 bg-transparent text-sm p-0 border-none"
                  value={serviceType}
                  onChange={(e) => {
                    setServiceType(e.target.value);
                    serviceHandler(e.target.value);
                  }}
                >
                  {/* <MenuItem value="0">All</MenuItem> */}
                  <MenuItem value="1">Correcting Constitution</MenuItem>
                  <MenuItem value="2">Change of Article</MenuItem>
                  <MenuItem value="3">Change of Name</MenuItem>
                  <MenuItem value="4">Change of Address</MenuItem>
                </Select>
              </InputGroup>
            </div>
            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>
          {/* {openDeleteModel && (
          <DeleteModel
            deleteDeviceLoading={deleteDeviceLoading}
            setOpenDeleteModel={setOpenDeleteModel}
            groupId={id}
            selectedItem={selectedItem}
            deleteDeviceMutate={deleteDeviceMutate}
          />
        )} */}

          {openUploadCertificateModel && (
            <UploadCertificateModel
              postUploadCertificate={postUploadCertificate}
              uploadCertificateLoading={UploadCertificateLoading}
              setOpenUploadCertificateModel={setOpenUploadCertificateModel}
              selectedItem={selectedItem}
            />
          )}

          {openUpdateStatusModel && (
            <UpdateStatusModel
              postUpdateStatus={postUpdateStatus}
              updateStatusLoading={UpdateStatusLoading}
              setOpenUpdateStatusModel={setUpdateStatusModel}
              serviceType={serviceType}
              selectedItem={selectedItem}
              userType={user.userType}
            />
          )}
          {openViewModel && (
            <ViewModel
              setOpenViewModel={setOpenViewModel}
              selectedItem={selectedItem}
              serviceType={serviceType}
            />
          )}

          {!isLoading && !isRefetching && (
            <TableWrapper>
              {serviceType == 1 && (
                <ChangeOfCorrectionTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  setOpenDeleteModel={setOpenDeleteModel}
                  setUpdateStatusModel={setUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenViewModel}
                  setOpenUploadCertificateModel={setOpenUploadCertificateModel}
                  setDeviceId={setDeviceId}
                  setDeviceType={setDeviceType}
                />
              )}

              {serviceType == 2 && (
                <ChangeOfArticleTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  setOpenDeleteModel={setOpenDeleteModel}
                  setUpdateStatusModel={setUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenViewModel}
                  setOpenUploadCertificateModel={setOpenUploadCertificateModel}
                  setDeviceId={setDeviceId}
                  setDeviceType={setDeviceType}
                />
              )}
              {serviceType == 3 && (
                <ChangeOfNameTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  setOpenDeleteModel={setOpenDeleteModel}
                  setUpdateStatusModel={setUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenViewModel}
                  setOpenUploadCertificateModel={setOpenUploadCertificateModel}
                  generateCertificate={generateCertificate}
                  setDeviceId={setDeviceId}
                  setDeviceType={setDeviceType}
                />
              )}

              {serviceType == 4 && (
                <ChangeOfAddressTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  setOpenDeleteModel={setOpenDeleteModel}
                  setOpenUpdateStatusModel={setUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenViewModel}
                  setOpenUploadCertificateModel={setOpenUploadCertificateModel}
                  setDeviceId={setDeviceId}
                  setDeviceType={setDeviceType}
                />
              )}
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
          {error && !isLoading && !isRefetching && <NotFoundModel />}
        </BoxContainer>
      </Page>
    </>
  );
};

const Filters = ({ initialValues, submitHandler, InitialLoading, user }) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs">
            <Label htmlFor="startDate">Start Date:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="startDate" id="startDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <InputGroup className="max-w-xs">
            <Label htmlFor="endDate">End Date:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <ApplyBtn disabled={InitialLoading} type="submit">
            Apply Date Filter
          </ApplyBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

// const Uploader = ({ setOpenUploadModel }) => {
//   return (
//     <UploadWrapper>
//       <Button type="button" onClick={() => setOpenUploadModel(true)}>
//         <MdAdd className="text-white w-5 h-5" /> <p>Run Campaign</p>
//       </Button>
//       {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
//         <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
//       </Button> */}
//     </UploadWrapper>
//   );
// };

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

const FilterContainer = tw.div`
grid grid-cols-2 w-full max-w-xl gap-4 md:flex md:space-x-4 items-end mt-12 md:mt-8`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-cyan-600 hover:bg-cyan-700  py-2.5 text-sm`;

export default OtherServices;
